module.exports = __webpack_public_path__ + "img/ultraip.c1111ecf.png";